<template>
	<v-container>
		<v-dialog title="学员学习状况" v-model="show" max-width="600">
			<v-card style="height: 400px;">
				<v-card-title>
					<span>学员学习状况</span>
					<v-spacer></v-spacer>
					<v-icon @click="cancel">mdi-close-circle</v-icon>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text style="max-height: 320px;overflow-y: auto;">
					
					<template v-if="items && items.length > 0">
						<v-sheet v-for="(item,index) in items" :key="index" class="flat mt-3 item_div pa-4">
							<div>
								<span>{{item.createAt}}</span>
								<span class="ml-2">{{item.className}}</span>
								<strong class="ml-3">{{item.creatorName}}</strong>
								<span class="ml-1">老师评写：</span>
							</div>
							<div class="mt-2">
								<span>{{item.briefDesc}}</span>
							</div>
						</v-sheet>
					</template>
					<template v-else>
						<v-sheet class="flat mt-3 item_div pa-4">
							<div>
								<span>暂无老师评写记录</span>
								
							</div>
							
						</v-sheet>
					</template>
				</v-card-text>
			</v-card>
		</v-dialog>

	</v-container>
</template>

<script>
	import utils from "../config/utils"
	export default {
		name: "student-situation-list",
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
			studentId: {
				type: String,
				default: ""
			}
		},
		watch: {
			show(newVal, oldVal) {
				console.log("newVal", newVal);
				this.hideShow = newVal;
				if (newVal) {
					this.getStudentSituationList();
				}
			},

		},
		data() {
			return {
				items: [],
				hideShow: this.show,
			}
		},
		mounted() {
			console.log("student-situation-list mounted");
		},
		methods: {
			getStudentSituationList() {
				const that = this;
				let url = `/edu/student/situation/list/${this.studentId}`;

				this.axios.get(url).then(response => {

					if (response.data["code"] === 200) {
						that.items = response.data["data"] ? response.data["data"] : [];
						return
					}
				})
			},
			cancel() {
				this.$emit("cancel", "");
			}
		}
	}
</script>

<style lang="scss" scoped>
	.item_div{
		border: #eeeeee 1px solid;
		border-radius: 20px;
	}
</style>
